import React from 'react';
import clsx from 'clsx';
import { Button, Tooltip, makeStyles } from '@material-ui/core';
import { isApplicationRestricted } from '../utils/applicationUtils';

const useStyles = makeStyles(theme => ({
	button: {
		width: '100%',
	},
	disabledButton: {
		backgroundColor: 'rgba(0, 0, 0, 0.12) !important',
		color: 'rgba(0, 0, 0, 0.26) !important',
		cursor: 'not-allowed',
		boxShadow: 'none !important',
	},
	viewButton: {
		border: '2px solid ' + theme.palette.secondary.main,
	},
}));

const RESTRICTED_TOOLTIP = 'Access Restricted: This position may be inactive or requires an invitation to apply.';

const ApplicationActionButtons = ({ application, onView, onEdit, onContinue }) => {
	const classes = useStyles();
	const isRestricted = isApplicationRestricted(application);

	return (
		<>
			{application?.viewApplicationGuid !== '' && (
				<Button
					className={clsx(classes.viewButton, classes.button)}
					size="large"
					variant="outlined"
					color="secondary"
					onClick={() => onView(application)}
				>
					View
				</Button>
			)}
			{application?.editApplicationGuid !== '' && (
				isRestricted ? (
					<Tooltip title={RESTRICTED_TOOLTIP} arrow placement="top">
						<Button
							className={clsx(classes.button, classes.disabledButton)}
							size="large"
							variant="contained"
							color="secondary"
						>
							Edit
						</Button>
					</Tooltip>
				) : (
					<Button
						className={classes.button}
						size="large"
						variant="contained"
						color="secondary"
						onClick={() => onEdit(application)}
					>
						Edit
					</Button>
				)
			)}
			{application?.continueApplicationGuid !== '' && (
				isRestricted ? (
					<Tooltip title={RESTRICTED_TOOLTIP} arrow placement="top">
						<Button
							className={clsx(classes.button, classes.disabledButton)}
							size="large"
							variant="contained"
							color="secondary"
						>
							Resume
						</Button>
					</Tooltip>
				) : (
					<Button
						className={classes.button}
						size="large"
						variant="contained"
						color="secondary"
						onClick={() => onContinue(application)}
					>
						Resume
					</Button>
				)
			)}
		</>
	);
};

export default ApplicationActionButtons;